import React from 'react';
import { RotateCcw } from 'lucide-react';
import { Tooltip } from '../../admin/components/shared/Tooltip.tsx';
import { AppSelect } from '../../shared/common/AppSelect.tsx';
import { ListPageSearchInput } from '../../shared/list-page/ListPageSearchInput.tsx';
import {
  RCM_CONTROL_TYPE_FILTER_OPTIONS,
  RCM_FREQUENCY_FILTER_OPTIONS,
  RCM_SIGNIFICANCE_FILTER_OPTIONS,
} from './rcmListConstants.js';

/**
 * RCM list filters: search, control type, significance, and frequency.
 */
export function RcmListFilters({
  searchQuery,
  onSearchQueryChange,
  filterControlType,
  onFilterControlTypeChange,
  filterSignificance,
  onFilterSignificanceChange,
  filterFrequency,
  onFilterFrequencyChange,
  onReset,
  columnVisibilityMenu = null,
}) {
  return (
    <div className="shrink-0 relative bg-white rounded-lg shadow-sm border border-gray-200 px-3 py-2 mb-2">
      <div className="flex flex-wrap 2xl:flex-nowrap items-center gap-2.5 min-w-0">
        <div className="flex-[1_1_18rem] min-w-[15rem]">
          <ListPageSearchInput
            placeholder="Search process, risk text, control text, performer, cycle name..."
            value={searchQuery}
            onChange={(e) => onSearchQueryChange(e.target.value)}
            aria-label="Search risk-control mappings"
          />
        </div>
        <div className="flex-[1_1_9.5rem] min-w-[9.5rem] max-w-[11.5rem]">
          <AppSelect
            value={filterControlType}
            onChange={(e) => onFilterControlTypeChange(e.target.value)}
            aria-label="Filter by control type"
            options={RCM_CONTROL_TYPE_FILTER_OPTIONS}
          />
        </div>
        <div className="flex-[1_1_9.5rem] min-w-[9.5rem] max-w-[11.5rem]">
          <AppSelect
            value={filterSignificance}
            onChange={(e) => onFilterSignificanceChange(e.target.value)}
            aria-label="Filter by control significance"
            options={RCM_SIGNIFICANCE_FILTER_OPTIONS}
          />
        </div>
        <div className="flex-[1_1_9.5rem] min-w-[9.5rem] max-w-[11.5rem]">
          <AppSelect
            value={filterFrequency}
            onChange={(e) => onFilterFrequencyChange(e.target.value)}
            aria-label="Filter by frequency"
            options={RCM_FREQUENCY_FILTER_OPTIONS}
          />
        </div>
        <Tooltip content="Reset filters" side="left">
          <button
            type="button"
            onClick={onReset}
            aria-label="Reset filters"
            className="z-10 inline-flex h-8 w-8 items-center justify-center rounded-full border border-gray-300 bg-white text-gray-600 transition-colors hover:bg-gray-50 hover:text-gray-800"
          >
            <RotateCcw className="h-3.5 w-3.5" />
          </button>
        </Tooltip>
        {columnVisibilityMenu}
      </div>
    </div>
  );
}
